import { SupportingDocumentsContent } from 'src/components';
import WorldPayDocumentContent from 'src/features/merchant/application/components/WorldPayDocumentContent';

const DocumentContent = ({
    isUploadSupportingDocumentsModalOpen,
    merchantApplication,
    id,
    supportingDocuments,
    setIsUploadSupportingDocumentsOpen,
    setIsWorldPayModalOpen,
    refetch,
    setDocumentsSubmitState,
}) => {
    const handleCancel = () => {
        setIsUploadSupportingDocumentsOpen(false);
        setIsWorldPayModalOpen(false);
    };

    const handleSentToWorldPay = () => {
        refetch();
        handleCancel();
    };

    if (isUploadSupportingDocumentsModalOpen) {
        return (
            <SupportingDocumentsContent
                isUploadingDocuments={isUploadSupportingDocumentsModalOpen}
                merchantApplication={merchantApplication}
                onCancel={handleCancel}
                setDocumentsSubmitState={setDocumentsSubmitState}
            />
        );
    }

    return (
        <WorldPayDocumentContent
            applicationId={id}
            supportingDocuments={supportingDocuments}
            legalName={merchantApplication?.merchantInformation?.aboutBusiness?.legalCompanyName}
            tradingName={merchantApplication?.merchantInformation?.aboutBusiness?.tradingName}
            onClose={handleCancel}
            onSentToWorldPay={handleSentToWorldPay}
        />
    );
};

export default DocumentContent;
